import Vue from 'vue'

const chainAddresses = require('./addresses.json')
Vue.prototype.$chainAddresses = chainAddresses

export default chainAddresses
